import React, {useState} from 'react';
import {Collapse, Row} from 'reactstrap';
import assets from "../../../../../util/assets";

MultipleSelectionCollapsableComponent.propTypes = {};

function MultipleSelectionCollapsableComponent(props) {

    const isOpen = props.selectAllCheckbox || props.checkboxStore.length > 0;

    return (
        <Collapse isOpen={isOpen}>
            <Row className="collapsable-container no-margin display-flex">
                <div className="display-flex-center">
                    <div className="collapsable-container-actions">
                        <div>
                            <img className="my-library-actions-img"
                                  src={assets.clipstore.collapse.multipleCollapsableDelete}/>
                        </div>
                        <div className="collapsable-container-action-title" onClick={props.deleteMany}>Delete</div>
                    </div>

                    <div className="collapsable-container-actions">
                        <div><img className="my-library-actions-img"
                                  src={assets.clipstore.collapse.multipleCollapsablePublish}/></div>
                        <div className="collapsable-container-action-title" onClick={props.publishMany}>Publish</div>
                    </div>
                </div>
            </Row>
        </Collapse>
    );
}

export default MultipleSelectionCollapsableComponent;